import { Component, Inject, OnInit } from "@angular/core";
import { CreateActivityComponent } from "../create-activity/create-activity.component";
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from "@angular/material/dialog";
import { SidebarService } from "src/app/services/sidebar.service";
import { P } from "@angular/cdk/keycodes";

@Component({
  selector: "app-reschedule-activity",
  templateUrl: "./reschedule-activity.component.html",
  styleUrls: ["./reschedule-activity.component.scss"],
  standalone: false
})
export class RescheduleActivityComponent implements OnInit {
  // registerForm: UntypedFormGroup;
  itemChecked: any = "";
  isFormDisable: boolean = false;
  isDataLoaded: boolean = false;
  activityTypeList: any = [
    { id: 1, name: "Site Done" },
    { id: 2, name: "Site Cancel" },
  ];
  regReq = {
    ActivityAction: "",
  };
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<"">,
    private dialog: MatDialog,
    private _formBuilder: UntypedFormBuilder,
    private sidebarService:SidebarService
  ) {
     
    // this.registerForm = this._formBuilder.group({
    //   ActivityAction: ["", Validators.required],
    // });
  }
  onSelectEvent(value: any) {
    setTimeout(() => {
      this.isFormDisable = true;
    }, 100);
    this.itemChecked = value;
  }
  ngOnInit() {
    this.sidebarService.GetActivityByProperty(this.data.propertyId).subscribe({
      next: (res) => {
        this.data.PropertyActivity = res[0];
        this.isDataLoaded = true;
      },
      error: (err) => {
      }
    });
  }
  nextActivity() {
    this.dialog.open(CreateActivityComponent, {
      // width      : '100%',
      // maxWidth   : '400px',
      // height     : 'auto',
      hasBackdrop: true,

      // panelClass : ‘personal-details-dialog‘,
      data: {
        type: true,
        PropertyActivity: this.data.PropertyActivity,
        propertyId: this.data.propertyId,
        ActivityAction: this.itemChecked,
      },
    });
    this.closeDialog();
  }
  closeDialog() {
    this.dialogRef.afterClosed().subscribe((result) => {});

    this.dialogRef.close("");
  }
}
